import { InjectionToken } from '@angular/core';
import { LogLevel } from './log-levels.enum';
import { CbreLogger } from './logger.model';

/**
 *
 */
export interface DebugActions {
  event: string;
  level?: LogLevel;
}

/**
 * LoggerConfiguration
 */
export const LoggerConfigurationToken = new InjectionToken<LoggerConfiguration>('LoggerConfiguration');
/**
 * Actual logger configuration
 */
export interface LoggerConfiguration {
  level: LogLevel;
  debugActions?: DebugActions[];
  logger?: CbreLogger;
}
